<div class="payment-failed-content text-center px-3 pt-4 mx-auto">
  <i
    class="fa fa-exclamation-circle payment-error-icon d-block mx-auto mb-3"
  ></i>
  <div class="payment-failed-title font-weight-bold font-size-header">
    {{ 'public.standalonepayment.paymentFailed.paymentFailed' | translate }}
  </div>
  <div class="payment-failed-subtitle mt-4 font-size-primary mx-auto">
    {{ 'public.checkout.progress.error.redirectMessage' | translate }}
  </div>
  <div
    class="countdown-circle mx-auto mt-4 d-flex align-items-center justify-content-center"
    [style.background]="getCountdownBackground(countdown)"
  >
    <span class="countdown-text">{{ countdown }}</span>
  </div>
</div>
